import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../lib/baseQueries";
import type { IContentResponse } from "./ContentTable.types";

interface GetContentsParams {
  page?: number;
  limit?: number;
}

export interface IDashboardStats {
  workspacesCount: number;
  collaboratorsCount: number;
  totalVideosCount: number;
  draftsCount: number;
  pendingCount: number;
  publishedCount: number;
  totalStorageUsed: number;
}

export const contentTableApi = createApi({
  reducerPath: "contentTableApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["ContentTable"],
  endpoints: (builder) => ({
    getContents: builder.query<IContentResponse, GetContentsParams | void>({
      query: (params) => {
        const page = params?.page ?? 1;
        const limit = params?.limit ?? 10;
        return `/v1/contents?page=${page}&limit=${limit}`;
      },
      providesTags: ["ContentTable"],
    }),

    deleteContent: builder.mutation<{ message: string }, string>({
      query: (contentId) => ({
        url: `/v1/contents/${contentId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error) => (error ? [] : ["ContentTable"]),
    }),

    getDashboardStats: builder.query<IDashboardStats, void>({
      query: () => "/v1/contents/stats",
      providesTags: ["ContentTable"],
    }),
  }),
});

export const {
  useGetContentsQuery,
  useDeleteContentMutation,
  useGetDashboardStatsQuery,
} = contentTableApi;
